<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'LOGIN.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <img src="assets/images/logo.png" alt="EZ Knews Logo" id="logo" />
  <div class="login-inputs">
    <ion-input color="primary" [(ngModel)]="email" type="email" placeholder=" {{ 'LOGIN.EMAIL_PLACEHOLDER' | translate }}"></ion-input>
    <ion-input color="primary" [(ngModel)]="password" type="password" placeholder=" {{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate }}"></ion-input>  
  </div>
  <div class="login-buttons">
  <ion-button expand="block" (click)="loginWithEmail()">{{ 'LOGIN.LOGIN_BUTTON' | translate }}
    <ion-icon slot="start" name="log-in-outline"></ion-icon>
  </ion-button>
  <ion-button expand="block" color="danger" (click)="loginWithGoogle()">
    <ion-icon slot="start" name="logo-google"></ion-icon>
    {{ 'LOGIN.GOOGLE_BUTTON' | translate }}
  </ion-button>
  <ion-button *ngIf="isNative" expand="block" color="dark" (click)="loginWithApple()">
    <ion-icon slot="start" name="logo-apple"></ion-icon>
    {{ 'LOGIN.APPLE_BUTTON' | translate }}
  </ion-button>
  <ion-button *ngIf="!temporary" id="guest-login" expand="block" (click)="getStarted()">
    {{ 'LOGIN.CONTINUE_AS_GUEST' | translate }}
    <ion-icon color="red" slot="start" name="rocket-outline"></ion-icon>
  </ion-button>
  </div>
  <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>

  <p>
    {{ 'LOGIN.NO_ACCOUNT' | translate }} <a (click)="goToSignUp()">{{ 'LOGIN.SIGN_UP' | translate }}</a>
  </p>
</ion-content>